import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import aboutUs from '@/views/aboutUs'
import newsCenter from '@/views/newsCenter/index'
import academicCenter from '@/views/academicCenter/index'
import academicCenterDetail from '@/views/academicCenter/detail'
import newsDetail from '@/views/newsCenter/detail'
import productCenter from '@/views/productCenter/index'
import productCenterDetail from '@/views/productCenter/detail'
import cooperativePartner from '@/views/cooperativePartner/index'
import video from '@/views/videoList/index'
import joinUs from '@/views/joinUs/index'
import videoListDetail from '@/views/videoList/detail'
import landingPage from '@/views/landingPage/index'
import brandHonors from '@/views/brandHonors/index'
import customer from '@/views/customerSupport/index'
import search from '@/views/search/index'
import productSearch from '@/views/productSearch/index'
import vueSitemap from '@/components/vue-sitemap'

import error404 from '@/components/error/404'
import error500 from '@/components/error/500'
import {menuList} from '@/api/common'

import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(Router)
Vue.use(Vant);

var list = [ 
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter
  },
  {
    path: '/newsCenter/:id',
    name: 'newsDetail',
    component: newsDetail
  },
  {
    path: '/academicCenter',
    name: 'academicCenter',
    component: academicCenter
  },
  {
    path: '/academicCenter/:id',
    name: 'academicCenterDetail',
    component: academicCenterDetail,
    title:'landingPage',
  },
  {
    path: '/productCenter',
    name: 'productCenter',
    component: productCenter
  },
  {
    path: '/productCenter/:id',
    name: 'productCenterDetail',
    component: productCenterDetail
  },
  {
    path: '/cooperativePartner',
    name: 'cooperativePartner',
    component: cooperativePartner
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
  {
    path: '/videoList/:id',
    name: 'videoListDetail',
    component: videoListDetail
  },
  {
    path: '/brandHonors',
    name: 'brandHonors',
    component: brandHonors
  },
  
  {
    path: '/joinUs',
    name: 'joinUs',
    component: joinUs
  },
  {
    path: '/customer',
    name: 'customer',
    component: customer
  },
  {
    path: '/search',
    name: 'search',
    component: search
  },
  {
    path: '/productSearch',
    name: 'productSearch',
    component: productSearch
  },
  {
    path: '/landingPage',
    name: 'landingPage',
    component: landingPage
  },
  {
    path: '/404',
    name: '404',
    component: error404
  },
  {
    path: '/500',
    name: '500',
    component: error500
  },

  {
    path: '/vueSitemap',
    name: 'vueSitemap',
    component: vueSitemap
  },
  
  
]

export default new Router({
  mode:'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: list
})


// WEBPACK FOOTER //
// ./src/router/index.js